//@ts-check
import {DataTable, SectionTitle} from '@/components-v2'
import {useProductCombo} from '@/context/ProductCombo/ProductComboContext'
import {useComboProductTableV2} from '@/hooks/productCombo/useComboProductTableV2'
import {comboProductTableColumns} from '@/utils/productCombo/productComboConstants'

const v2Columns = comboProductTableColumns.map(col => ({
  ...col,
  columnKey: col.name_of_db_column,
  header: col.label_of_column,
  columnFilterPlaceholder: col.label_of_column,
}))

export const ComboProductTable = () => {
  const {
    productCombo: {productLimit},
  } = useProductCombo()
  const {
    tableData,
    onPageIndexChange,
    sortingHandler,
    onColumnFiltersChange,
    resetFilterButtonOptions,
    onTableReady,
    rowSelectionStateUpdater,
    initialRowSelection,
    pageIndex,
    pageSize,
    totalRowsCount,
    onRowsPerPageChange,
  } = useComboProductTableV2()

  return (
    <div className="flex flex-col gap-4 rounded-lg bg-[var(--color-background-layer-01)] p-6">
      <div className="flex items-center justify-between">
        <SectionTitle label="Product Table" />
      </div>
      <DataTable
        columns={v2Columns}
        // isLoading={isFetching}
        data={tableData}
        pageIndex={pageIndex}
        pageSize={pageSize}
        totalRowsCount={totalRowsCount}
        onPageIndexChange={onPageIndexChange}
        manualPagination
        manualSorting
        manualFiltering
        sortingHandler={sortingHandler}
        size="small"
        onColumnFiltersChange={onColumnFiltersChange}
        onRowsPerPageChange={onRowsPerPageChange}
        resetFilterButtonOptions={resetFilterButtonOptions}
        selection="multiple"
        maxRowSelection={/** @type {number} */ (productLimit)}
        initialRowSelection={initialRowSelection}
        onTableReady={onTableReady}
        rowSelectionStateUpdater={rowSelectionStateUpdater}
      />
    </div>
  )
}
